import {
  AssignCarrierDrawer,
  BookingDetailDrawer,
  resolveBookingCustomerDetailLink,
  resolveBookingDetailCarrierHandlers,
} from "design-components";
import { EditBookingWizard } from "../../bookings/components/edit-booking-wizard.component";
import { BookingDeleteDrawer } from "../../bookings/components/booking-delete-drawer.component";
import type { useCarrierDetailBookingsActions } from "../hooks/use-carrier-detail-bookings-actions";
import { OPERATOR_SCOPED_ID } from "../../../shared/constants/operator.constants";

type BookingsActions = ReturnType<typeof useCarrierDetailBookingsActions>;

export interface CarrierDetailBookingsOverlaysProps {
  bookings: BookingsActions;
}

export const CarrierDetailBookingsOverlays = ({
  bookings,
}: CarrierDetailBookingsOverlaysProps) => {
  return (
    <>
      <EditBookingWizard
        open={bookings.editBookingOpen}
        bookingId={bookings.editBookingId}
        onClose={bookings.handleCloseEditBooking}
        operatorId={OPERATOR_SCOPED_ID}
        onBookingUpdated={bookings.handleEditBookingUpdated}
      />
      <AssignCarrierDrawer
        open={bookings.assignCarrierBooking != null}
        onClose={bookings.handleCloseAssignCarrier}
        booking={bookings.assignCarrierBooking}
        carrierOptions={bookings.carrierAssignSelectOptions}
        carriersLoading={bookings.assignDrawerCarriersLoading}
        onAssign={bookings.handleConfirmAssignCarrier}
        onDotLookup={bookings.handleDotLookup}
      />
      <BookingDeleteDrawer
        key={bookings.bookingToDelete?.bookingId ?? "closed"}
        open={bookings.bookingToDelete != null}
        onClose={bookings.handleCloseDeleteDrawer}
        booking={bookings.bookingToDelete}
        carrierAssignments={bookings.deleteCarrierAssignments}
        containerQuantity={bookings.deleteContainerQuantity}
        isMultipiece={bookings.deleteIsMultipiece}
        canNotifyCarrier={bookings.deleteCanNotifyCarrier}
        initialRecipients={bookings.deleteInitialRecipients}
        initialMessageBody={bookings.deleteInitialMessageBody}
        loading={bookings.deletePreviewLoading}
        submitError={bookings.deleteSubmitError}
        onClearSubmitError={bookings.handleClearDeleteSubmitError}
        onConfirm={bookings.handleConfirmDeleteBooking}
      />
      <BookingDetailDrawer
        open={bookings.detailOpen}
        loading={bookings.detailLoading}
        error={bookings.detailError}
        detail={bookings.detailModel}
        hideCarrierName
        customerDetailLink={resolveBookingCustomerDetailLink(bookings.detailContextRow)}
        onClose={bookings.handleCloseDetail}
        onDone={bookings.handleCloseDetail}
        onEdit={bookings.detailModel?.actionsAllowed ? bookings.handleDetailEdit : undefined}
        {...resolveBookingDetailCarrierHandlers({
          detail: bookings.detailModel,
          singlePieceAssignEnabled: Boolean(bookings.detailAssignToolbarAction?.enabled),
          onAssignOrReassign: bookings.handleDetailReassign,
          onUnassign: bookings.handleDetailUnassignCarrier,
        })}
        assignCarrierMenuLabel={bookings.assignCarrierMenuLabel}
        onDelete={bookings.detailModel?.actionsAllowed ? bookings.handleDetailDelete : undefined}
      />
    </>
  );
};
